import BuscaSimplesCards from '@/components/BuscaSimplesCards.vue';

export const mixinProjetoGovernador = {
  components: {
    BuscaSimplesCards,
  },
  data() {
    return {
        cardsProjetoGovernador: [
            {
              rota: 'PorAnoProjetoGovernador',
              icone: require('@/assets/images/icon-indice-cronologico2.png'),
              iconeClasse: 'indice-icon',
              titulo: 'Índice Cronológico',
              descricao: 'Consulte Projetos<br /> por <strong>ano</strong>',
            },
          ],
    };
  },
};